import { Component, Input, OnInit } from '@angular/core';
import { OrganizationModel } from '../../models/organization.model';
import { StudyModel } from '../../models/study.model';

@Component({
    selector: 'study-footer',
    templateUrl: './study-footer.html',
    styleUrls: ['./study-footer.scss']
})
export class StudyFooterComponent implements OnInit{

    // Properties
    public studyPartnerEmail : string = "";

    constructor() {}

    // Bindings
    @Input() organizationModel: OrganizationModel;
    @Input() studyModel: StudyModel;

    ngOnInit(){
       this.studyPartnerEmail = (this.studyModel) ?  this.studyModel.get('contact_email') : "";
    }

    getOrganizationName(organizationModel) {
        return organizationModel ? organizationModel.get('friendly_name') ? organizationModel.get('friendly_name') : organizationModel.get('name') : '';
    }

    openMailTo(emailAddress) {
        window.location.href = `mailto:${emailAddress}`;
    }
}


// WEBPACK FOOTER //
// ./src/app/partials/study-footer/study-footer.component.ts